import React from 'react'
import Lottie from 'lottie-react';
import "./ServerDown.css";
import serverAnimation from "../animations/server under maintenance.json"

const ServerDown = () => {
  return (
    <div className='downContainer'>
      <div className='downContent'>
        <div className="lottie-crop-down">
          <Lottie animationData={serverAnimation} loop />
        </div>
        <h2><span className='iconserverdwn'>⛓️‍💥</span> Server is down</h2>
        <p>Please try again later.</p>
      </div>
    </div>
  )
}

export default ServerDown